import CircleIcon from "@mui/icons-material/Circle";
import React from "react";
import { ListStateIcon } from "../ListStateIcon";

interface IListStateIconBallProps {
    noMargin?: boolean;
    tooltip?: string;
}

export const ListStateIconBall = (props: IListStateIconBallProps) => {
    return (
        <ListStateIcon
            icon={CircleIcon}
            tooltip={props.tooltip}
            noMargin={props.noMargin}
        />
    );
};
